const svgModules = import.meta.glob("/src/assets/images/numbers/*.svg", { eager: true });

const iconsMap = new Map<number, string>();

Object.entries(svgModules).forEach(([path, mod]) => {
  const match = path.match(/(\d+)\.svg$/);
  if (match) {
    const num = Number(match[1]);
    const src = (mod as any)?.default || (mod as any);
    iconsMap.set(num, src);
  }
});

export default iconsMap;
